<template>
  <div>
    <template v-if="isExpired && dataTrip.is_booked === false">
      <DJButton
        :id="`${buttonIdPrefix}-extend-offer`"
        :class="customClass"
        :size="size"
        :loading="loadingBookReserve"
        :type="bookableType"
        :suffix-icon="showSuffixIcon ? IconCaretRight : null"
        @click.prevent="toCheckOut"
      >
        {{ dataTrip.type === `bookable` ? `Extend This Offer` : `Validate Offer` }}
      </DJButton>
    </template>
    <template v-else>
      <DJButton
        v-if="route.name === 'trip-plan'"
        :id="buttonID"
        :class="customClass"
        :size="size"
        :suffix-icon="showSuffixIcon ? IconCaretRight : null"
        type="accent"
        @click="emit('customTrip')"
      >
        <span class="text-md-sb">{{ btnCustomiseLabel }}</span>
      </DJButton>
      <DJButton
        v-else
        :id="`${buttonIdPrefix}-pay`"
        :class="customClass"
        :size="size"
        :type="bookableType"
        :suffix-icon="showSuffixIcon ? IconCaretRight : null"
        @click.prevent="toCheckOut"
      >
        {{ btnBookLabel }}
      </DJButton>
    </template>
  </div>
</template>
<script setup>
import { ref, computed, inject } from "vue"
import { useRoute } from 'vue-router'
import DJButton from '~/components/ui/button/Button.vue'
import { IconCaretRight } from '~/components/ui/icon/icons'
import bookApi from '~/composables/api/bookApi'
import { isEmpty } from '~/helper'
import { useCurrenciesStore } from '~/store/pinia/currencies'
import { useEnquiryCaptureStore } from '~/store/pinia/enquiryCapture'
import { useAuthStore } from '~/store/pinia/auth'
import { useTripPlanStore } from '~/store/pinia/tripPlan'

const props = defineProps({
  customClass: { type: String, default: '' },
  size: { type: String, default: 'large' },
  buttonType: { type: String, default: '' },
  showSuffixIcon: { type: Boolean, default: false },
  buttonID: { type: String, default: '' },
  buttonIdPrefix: { type: String, default: '' },
})

const emit = defineEmits(['checkout', 'customTrip', 'handleBook'])

const isExpired = inject('isExpired', false)
const showCountDown = inject('showCountDown', false)

const enquiryCaptureStore = useEnquiryCaptureStore()
const authStore = useAuthStore()
const route = useRoute()
const loadingBookReserve = ref(false)
const currenciesStore = useCurrenciesStore()
const tripPlanStore = useTripPlanStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)
const stepsData = computed(() => enquiryCaptureStore.stepsData)
const currencySelected = computed(() => currenciesStore.currencySelected /*store.state.currenciesStore.currencySelected*/)
const userInfo = computed(() => authStore.getUserInfo)
const btnBookLabel = computed(() => {
  let label = ''
  if (dataTrip.value.is_full_payment === false && dataTrip.value.is_defined_date === true) {
    if (dataTrip.value.is_booked === false) label = 'Pay Deposit'
    else label = 'Pay Balance'
  }
  // else if(domain === 'agent') label = 'Confirm Now'
  else {
    label = 'Pay Balance'
  }
  return label
})
const bookableType = computed(() => {
  if (props.buttonType) return props.buttonType
  if (isExpired?.value) {
    return `primary`
  } else if (dataTrip.value?.valid_time && showCountDown.value) {
    return `warning`
  }
  return 'accent'
})
const btnCustomiseLabel = computed(() => {
  if (process.server) return 'Design your trip today'
  if (!isEmpty(stepsData.value) && (stepsData.value[`${route.path}/design`] || stepsData.value[route.path])) {
    return 'Continue to Customise'
  }
  return 'Design your trip today'
})

async function toCheckOut() {
  sessionStorage.setItem('trip_id', dataTrip.value.id)
  loadingBookReserve.value = true
  try {
    const res = await bookApi.reserve({
      proposal_id: dataTrip.value.id,
      currency: currencySelected.value.code,
      customer_id: userInfo.value.userId,
    })
    if (res.data.error === 0) {
      if (res.data.data.booking_id) {
        //return navigateTo({ name: 'checkout-balance', params: { orderId: res.data.data.booking_id }, query: { traffic: 1 } })
        window.location.href = `/checkout/balance/${res.data.data.booking_id}?traffic=1`
      } else {
        //return navigateTo({ name: 'checkout', query: { traffic: 1 } })
        window.location.href = `/checkout?traffic=1`
      }
    } else {
      emit('handleBook', res.data.data)
    }
  } catch (err) {
    console.log(err)
  } finally {
    loadingBookReserve.value = false
  }
}
</script>
